import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import CandLgBar from './components/CandLgBar'
import { DummyAfterLogin } from '../../pages/CommonPublicPages/Navbars/components/DummyAfterLogin'
// import './CDash.css'

function CDashh() {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)

  // Sync collapse state from sidebar (desktop)
  useEffect(() => {
    const handleSidebarCollapseChange = (event) => {
      setIsCollapsed(event.detail.isCollapsed)
    }
    document.addEventListener('sidebarCollapseChange', handleSidebarCollapseChange)
    return () => {
      document.removeEventListener('sidebarCollapseChange', handleSidebarCollapseChange)
    }
  }, [])

  // Listen for mobile open/close events from navbar
  useEffect(() => {
    const handleToggleSidebar = (event) => {
      setIsMobileSidebarOpen(event.detail.isOpen)
    }
    document.addEventListener('toggleSidebar', handleToggleSidebar)
    return () => {
      document.removeEventListener('toggleSidebar', handleToggleSidebar)
    }
  }, [])

  const closeMobileSidebar = () => {
    const evt = new CustomEvent('toggleSidebar', { detail: { isOpen: false } })
    document.dispatchEvent(evt)
  }

  const desktopMargin = isCollapsed ? 'lg:ml-20' : 'lg:ml-64'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <CandLgBar />

      {/* Navbar - offset on desktop by sidebar width */}
      <div className={`sticky top-0 z-50 bg-white ${desktopMargin} transition-[margin] duration-300`}>
        <DummyAfterLogin />
      </div>

      {/* Mobile overlay below navbar */}
      {isMobileSidebarOpen && (
        <div
          className="fixed inset-0 top-14 md:top-16 lg:hidden bg-black/40 z-30"
          onClick={closeMobileSidebar}
          aria-hidden="true"
        />
      )}

      {/* Main content - offset on desktop by sidebar width */}
      <main className={`${desktopMargin} transition-[margin] duration-300`}>
        <div className="">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default CDashh